/**
 * Created by lu on 2018/4/8.
 */
var nb = require('./nb');
var app = require('./app');
var languageData = require('./model/Language');
var userModel = require('./model/User');
module.exports = nb.define({
    parent: app.Model,
    mapping: {
        header: require('./model/Header'),
        footer: nb.Model
    },
    method: {
        init: function () {

            this.set('nbModel', nb.model);   //todo console

            nb.model.set('ajaxReady', 'data-ready');//ajax 遮罩
            //监听到ajax loading
            nb.model.onChange('ajaxReady', function (inEvent, inState) {
                this.set('ajaxReady', inState);
            }, this);


            userModel.set('isOnlyWater', this._isOnlyWater());
            userModel.set('isPageLogin', this._isPageLogin());
            userModel.set('checkCompleteInfo', this._checkCompleteInfo());

            //监听到loading   set 状态
            nb.model.onChange('dataReady', function (inEvent, inState) {
                this.set('dataReady', inState);
            }, this);

            //默认中文
            nb.model.onChange(nb.opts.clientReady, function (inEvent) {
                var key = $.cookie('b2b-language') || 'cn';
                nb.model.set('switchLanguage', key);

                userModel.onChange('loginReady', function () {
                    nb.model.set(nb.model.user, userModel);
                }, this);

            }, this);

            //切换中英文
            nb.model.onChange('switchLanguage', function (inEvent, inKey) {
                this.setLanguageData(inKey);
                nb.model.set('changeLanguageReady', inKey, {skipSameValue: false})
            }, this);
        },

        setLanguageData: function (inKey) {
            var config = this.get('config');

            languageData.setData(inKey);

            this.setOpts({
                header: languageData.get('header'),
                footer: languageData.get('footer'),
                notice: languageData.get('notice'),
                content: config.language[inKey]
            });

            nb.model.setOpts({
                prompt: languageData.get('prompt')
            })

        },
        _checkCompleteInfo: function () {
            return true;
        },
        _isPageLogin: function () {
            return true;
        },
        _isOnlyWater: function () {
            return false;
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/Model.js
// module id = 13
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39